import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportSatisfacaoClientePesquisaUseCase } from "../../../presentation/useCases/read/get_report_satisfacao_cliente_pesquisa_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportSatisfacaoClientePesquisaUseCase
 */

export class GetReportSatisfacaoClientePesquisaUseCase implements IGetReportSatisfacaoClientePesquisaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportSatisfacaoClientePesquisa(
    requiredMimeType: ReportMimeType | null,
    idPesquisaSatisfacaoCliente: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportSatisfacaoClientePesquisa(
      requiredMimeType,
      idPesquisaSatisfacaoCliente,
    );

    if (response.mimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `saldo_bancario_${idPesquisaSatisfacaoCliente}_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
